module.exports = __webpack_public_path__ + "img/H-45-ER-550-MI.0a73945c.png";